import { debounce } from "../../utils/common";
import { Component, register } from "../../core";
import {addEvent} from '../../utils/gaService'

/**
 * Partial templates for this component
 */
const partials = {
    // Suggestions template
    suggestions: (suggestions = []) => suggestions.reduce((html, locality) => html + `
    	<li class="show ${locality.selected ? 'selected' : ''}" title="${locality.name}" data-ref="suggestion" data-key="${locality.id}">
            <div class="input-div">
                <input type="checkbox" id="locality-${locality.id}" ${locality.selected ? 'checked' : ''} />
                <label for="locality-${locality.id}">${locality.name}</label>
            </div>
        </li>
       `, ''),
};

/**
 * Template for the component
 * 
 * @param {Object} state the state of this component
 */
const template = (state) => `
	<div data-ref="locality-search">
		<div class="search">
			<input type="text" data-ref="search" placeholder="Search for Locality" />
		</div>
	    <ul class="filter_listing" data-ref="suggestions">
	            ${partials.suggestions(state.topSuggestions)}
	        </ul>
	    </ul>
	    <div class="apply">
	        <button id="localityFilter" data-ref="apply-locality">Apply</button>
	    </div>
	</div>
`;

/**
 * The initial state of this component
 */
const initialState = {
    cityId: null,
    suggestions: [],
    topSuggestions: [],
    selectedlocalitys: [], 
};

/**
 *  "Cowork Locality" filter component
 * 
 * @extends Component
 * @author Saravanan
 */
export class CoworkLocalitySearchComponent extends Component {
    
    static alias = 'locality-filter';
    static template = template;
 
    constructor(el, state) {
        super(el, {...initialState, ...state});
    }

    /**
     * Lifecycle hook that is trigerred after component has loaded
     */
    onComponentLoaded() {
        
        // The event handlers has to be explicitly bound to `this` scope
        this.onClickSelectSuggestion = this.onClickSelectSuggestion.bind(this);
        this.onChangeLoadSuggestions = this.onChangeLoadSuggestions.bind(this);
        this.handleDropdownClick = this.handleDropdownClick.bind(this);

        // Initialize the event handlers
        this.refs.search.addEventListener('input', debounce(this.onChangeLoadSuggestions, 300));
        this.refs.suggestions.addEventListener('click', this.onClickSelectSuggestion);
        //this.delegate('click', this.refs.suggestions, { 'suggestion': this.onClickSelectSuggestion });

        // Load the top places of interest for the current city
        this.loadTopSuggestions(this.state.cityId);

        this.refs.suggestions.addEventListener('click', this.handleDropdownClick);
    }

    /**
     * Event handler to load locality suggestions against the query
     * 
     * @param {KeyboardEvent} event the `input` event
     */
    onChangeLoadSuggestions(event) {
        const {target} = event;
        const query = target.value.trim();

        if (query) {
            // Load the suggestions and render them
            this.loadSuggestions(query, this.state.cityId);
        } else {
            // Render the top suggestions if nothing to search
            this.renderSuggestions(this.state.topSuggestions);
        }
    }

    /**
     * Event handler to that delegates `click` event on the suggestions list
     * 
     * @param {MouseEvent} event the `click` event
     * @param {Object} data the attribute dataset
     */
    onClickSelectSuggestion(event) {
        let eventname = event.target.htmlFor;
        let getId = eventname.split("-");
        
        // Check if the locality is already selected
        const selectedlocalitys = [...this.state.selectedlocalitys];
        const idxSelectedlocality = selectedlocalitys.findIndex((locality) =>locality.id == getId[1]);

        // Unselect if already selected
        if (idxSelectedlocality >= 0) {
            // Remove the locality from the selected list
            selectedlocalitys.splice(idxSelectedlocality, 1);
        } else {
            // Find the selected locality id from the suggestions
            const selectedlocality = this.state.suggestions.find((locality) => locality.id == getId[1]);

            // Add the locality to the list of selected ids
            if (selectedlocality) {
                selectedlocality.selected = true;
                selectedlocalitys.push(selectedlocality);
            } 
        }

        // Update the state
        this.setState({
            ...this.state,
            selectedlocalitys: selectedlocalitys,
            suggestions: this.mapToSelectedlocalitys(this.state.suggestions, selectedlocalitys)
        });

        // Render the suggestions and emit an event to notify about this selection 
        this.renderSuggestions(this.state.suggestions);
        this.emit('locality.selected', this.state.selectedlocalitys);
    }

    /**
     * Load the top suggestions for the provided city
     * 
     * @param {number} cityId realestate city id
     */
    loadTopSuggestions(cityId) {
        this.fetchTopSuggestions(cityId)
            .then((topSuggestions) => this.mapToSelectedlocalitys(topSuggestions))
            .then((topSuggestions) => {
                // Update the state
                this.setState({
                    ...this.state, 
                    topSuggestions,
                    suggestions: topSuggestions
                });

                // Render the top suggestions
                this.renderSuggestions(this.state.topSuggestions);
            });
    }

    /**
     * Loads the suggestions for the given query
     * 
     * @param {string} query the locality name query
     * @param {string} cityId realestate city id
     */
    loadSuggestions(query, cityId) {
        this.fetchSuggestions(query, cityId)
            .then((suggestions) => this.mapToSelectedlocalitys(suggestions))
            .then((suggestions) => {
                // Update the state
                this.setState({...this.state, suggestions});
                
                // Render suggestions
                this.renderSuggestions(this.state.suggestions);
            });
    }

    /**
     * Fetches the top suggestions for the given city
     * 
     * @param {string} cityId realestate city id 
     */
    fetchTopSuggestions(cityId) {
    	let formData = new FormData();
    	formData.append('cityId',cityId);
    	formData.append('source','qh');
    	formData.append('limit',5);
    	formData.append('entityType','Project');
        return fetch(`/homes/re2/getallLocality`, {
		        method: 'POST',
		        body: formData, 
		    }).then((res) => res.json());
    }

    /**
     * Fetches the suggestions for the given query
     * 
     * @param {string} query the locality name query
     * @param {string} cityId realestate city id
     */
    fetchSuggestions(query, cityId) {
    	let formData = new FormData();
    	formData.append('cityId',cityId);
    	formData.append('query',query);
    	formData.append('limit',5);
        return fetch(`/homes/re2/locality_auto_suggest`, {
		        method: 'POST',
		        body: formData, 
		    }).then((res) => res.json());
    }

    renderSpinner(show = true) {
        if (show) {
            this.refs.spinner.classList.remove('hide');
        } else {
            this.refs.spinner.classList.add('hide');
        }
    }

    /**
     * Renders the places of interest partial
     * 
     * @param {Array} suggestions 
     */
    renderSuggestions(suggestions = []) {
        //console.log(suggestions);
        if(suggestions.length <= 0) {
            this.refs.applyLocality.disabled = true;
        } else {
            this.refs.applyLocality.disabled = false;
        }
        this.refs.suggestions.innerHTML = partials.suggestions(suggestions);
    }

    /**
     * Renders the selected localitys
     * 
     * @param {Array} selectedlocalitys the selected localitys
     */
    renderSelectedlocalitys(selectedlocalitys = []) {
        this.refs.selection.innerHTML = partials.suggestions(selectedlocalitys);
    }

    /**
     * Maps the localitys to selected localitys
     * 
     * @param {Array} localitys the places of interest
     * @param {Array} selectedlocalitys the selected localitys
     */
    mapToSelectedlocalitys(localitys = [], selectedlocalitys = this.state.selectedlocalitys) {
        // Filter all the localitys 
        const toplocalitys = localitys.map((locality) => ({...locality, selected: selectedlocalitys.findIndex((slocality) => slocality.id == locality.id) >= 0}));
        const restlocalitys = selectedlocalitys.filter((slocality) => slocality.localityName).filter((slocality) => -1 === localitys.findIndex((locality) => slocality.id == locality.id));

        // Merge both the lists
        return [...restlocalitys, ...toplocalitys];
    }

    handleDropdownClick(ev) {
    	event.stopPropagation()
    }

}

// Register this component
register(CoworkLocalitySearchComponent);